const ElementoAer = (props) => {

    const formato = 'text-center'

   
    return (<>
       <div className="w-full flex bg-zinc-200 flex-row justify-between" onClick={e => props.setUpdData(props.obj)} key={props.obj.id}>
  <input 
    type="checkbox" 
    id={props.obj.id}  
    checked={props.obj.s}
    onChange={(e => props.elegir(props.obj.id))}
  />
  <div className="px-5 grid grid-cols-9 w-full gap-2">
  <label className="truncate min-w-0" title={props.obj.apellido}>
    {props.obj.apellido}
  </label>
  
  <label className="truncate min-w-0" title={props.obj.nombre}>
    {props.obj.nombre}
  </label>
  
  <label className='truncate min-w-0' title={props.obj.email}>
    {props.obj.email || ''}
  </label>
  
  <label className="truncate min-w-0">
    {props.obj.documento}
  </label>
  
  <label className={(props.obj.inscripto ? 'text-green-600' : 'text-red-600') + ' flex justify-center truncate min-w-0'}>
    {props.obj.inscripto ? 'Si' : 'No'}
  </label>
  
  <label className={(props.obj.acomp ? 'text-green-600' : 'text-red-600') + ' flex justify-center truncate min-w-0'}>
    {props.obj.acomp ? 'Si' : 'No'}
  </label>
  
  <label className='flex justify-center text-green-600 truncate min-w-0'>
    {props.obj.expositor ? 'Si' : ''}
  </label>
  
  <label className='flex justify-center truncate min-w-0'>
    {props.obj.cliente}
  </label>
  
  <label className={formato + " truncate min-w-0"}>
    {props.evento.prefijoqr + props.obj.id.toString().padStart(parseInt(props.evento.cifrasqr),'0')}
  </label>
</div>
</div>
        </>)
}

export default ElementoAer